import React from 'react';
const stats = [{
  value: '+500',
  label: 'personas que duermen mejor'
}, {
  value: '4',
  label: 'módulos y bonos'
}, {
  value: '200+',
  label: 'páginas listas'
}, {
  value: '4.9/5',
  label: 'calificación'
}];
export function Stats() {
  return <section className="bg-cream py-8 md:py-12 px-4" data-id="element-400">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-401">
        {stats.map((stat, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-sage-soft text-center" data-id="element-402">
            <p className="font-display font-bold text-sage text-[36px] mb-2" data-id="element-403">
              {stat.value}
            </p>
            <p className="font-sans font-light text-taupe text-sm" data-id="element-404">
              {stat.label}
            </p>
          </div>)}
      </div>
    </section>;
}